/* KARAVIRS — header nav drawer (mobile)
   Reuses Dawn's global trapFocus/removeTrapFocus rather than reimplementing them. */
(function () {
  'use strict';

  function bind(header) {
    if (header.dataset.kvHeaderBound === 'true') return;
    header.dataset.kvHeaderBound = 'true';

    var drawer = header.querySelector('[data-kv-drawer]');
    var openBtn = header.querySelector('[data-kv-drawer-open]');
    var closeBtn = header.querySelector('[data-kv-drawer-close]');
    if (!drawer || !openBtn) return;

    /* Closed at rest: CSS visibility:hidden already removes it from the tab order
       and the accessibility tree; inert is belt-and-braces. */
    drawer.setAttribute('inert', '');

    function isOpen() {
      return drawer.classList.contains('is-open');
    }

    function open() {
      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');
      if (typeof trapFocus === 'function') trapFocus(drawer, closeBtn || drawer);
      else if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (!isOpen()) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(openBtn);
      else openBtn.focus();
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);

    /* Focus is trapped inside the drawer while open, so a listener here catches Escape.
       Scoped to the drawer so re-rendering the section in the theme editor cannot leak
       document-level listeners. */
    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.stopPropagation();
        close();
      }
    });

    /* Following a link leaves the page; drop the scroll lock so a restored
       back/forward page is not left frozen. */
    drawer.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', close);
    });
  }

  function init() {
    document.querySelectorAll('[data-kv-header]').forEach(bind);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
